import { useQuery } from "@tanstack/react-query";

import { getMyUser } from "@/api";

const useGetProfile = () => {
  return useQuery({
    queryKey: ["my-user"],
    queryFn: getMyUser,
    refetchOnWindowFocus: false,
    meta: { withoutError: true },
  });
};

export { useGetProfile };
